var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map map-mini" }, [
    _c("div", { staticClass: "map-inner", attrs: { id: _vm.id } }, [_vm._m(0)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "static-marker" }, [
      _c("i", { staticClass: "beepiz-marker" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }